var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasUser)?_c('div',[_c('TryNewBack'),_c('div',{staticClass:"pa-3"},[_c('BizLogo')],1),_c('InvoiceGuard',[_c('div',{staticClass:"s-vstack"},[_c('StripeAccountGuard')],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }